<template>
	<div
		class="icon"
		:class="{sticky}"
		@mouseover="active = true"
		@mouseleave="active = false"
		@click="active = !active"
	>
		<span class="svg" v-html="icon('tooltip')"></span>
		<transition name="fade">
			<div class="tooltip" v-if="active">
				<div class="tooltip-wrap">
					<slot></slot>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	props: {
		sticky: Boolean
	},
	data() {
		return {
			active: false
		};
	}
};
</script>

<style lang="scss" scoped>
.icon {
	position: absolute;
	right: calc(100% + 0.5em);
	top: 0;
	bottom: 0;
	margin: auto;
	transition: opacity 0.2s ease-in-out;
	display: flex;
	align-items: center;

	&.sticky {
		opacity: 0;
	}

	@include mobile {
		display: none;
	}

	.svg {
		display: inline-flex;
		::v-deep {
			svg {
				$s: 14px;
				width: $s;
				height: $s;

				@include res {
					$s: 13px;
					width: $s;
					height: $s;
				}
			}
		}
	}

	.tooltip {
		padding-bottom: 1.25em;
		bottom: 100%;
		position: absolute;
		z-index: 1;
		transform: translateX(50%);
		right: 50%;

		&-wrap {
			position: relative;
			background-color: $white1;
			font-size: 0.8em;
			line-height: 1.3em;
			padding: 1em 1em;
			border-radius: 4px;
			width: 12em;
			max-width: 100%;
			box-shadow: 0 1px 5px #c4c3c3;
			color: $black1;
			text-align: center;
			user-select: none;

			&:after {
				top: 100%;
				left: 50%;
				border: solid transparent;
				content: " ";
				height: 0;
				width: 0;
				position: absolute;
				pointer-events: none;
				border-top-color: $white1;
				border-width: 10px;
				margin-left: -10px;
			}
		}
	}
}

$trans: 0.1s;

.fade-enter-active,
.fade-leave-active {
	transition: transform $trans ease, opacity $trans ease;
}
.fade-enter,
.fade-leave-to {
	// transform: translateY(-25px);
	opacity: 0;
}
</style>
